/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { WifiMode } from './models';
import { WifiProtocol } from './models';
import { WifiSSIDVisibility } from './models';
import { WifiKeyVisibility } from './models';

export const wifiMode = createEnumConverter<WifiMode>(WifiMode, 1);

export const wifiModeArray = createEnumArrayConverter<WifiMode>(WifiMode, 1);

export const wifiProtocol = createEnumConverter<WifiProtocol>(WifiProtocol, 1);

export const wifiProtocolArray = createEnumArrayConverter<WifiProtocol>(
  WifiProtocol,
  1,
);

export const wifiSSIDVisibility = createEnumConverter<WifiSSIDVisibility>(
  WifiSSIDVisibility,
  1,
);

export const wifiSSIDVisibilityArray =
  createEnumArrayConverter<WifiSSIDVisibility>(WifiSSIDVisibility, 1);

export const wifiKeyVisibility = createEnumConverter<WifiKeyVisibility>(
  WifiKeyVisibility,
  1,
);

export const wifiKeyVisibilityArray =
  createEnumArrayConverter<WifiKeyVisibility>(WifiKeyVisibility, 1);
